export default [
  {
    question: `What do I need to know?`,
    answer: `Staking via Unagii delegates to the Stakewithus validator to help secure the network and receive a share of incentivized rewards earned. Rewards are earned by staking tokens and are paid out on a per block basis. Users can withdraw or compound at any time.`,
  },
  {
    question: "What is the inflation?",
    answer: `All rewards come from inflationary rewards at 7% per year and gas transaction fees on Terra's network, paid in LUNA`,
  },
  {
    question: `Is there a lock-up period?`,
    answer: `There is a 21 days unbonding period when unstaking LUNA from the network. Users will not earn rewards and will be susceptible to slashing during unbonding.`,
  },
  {
    question: `How to restake?`,
    answer: `Users may manually withdraw rewards and restake to compound their returns.`,
  },
  {
    question: `Is there a fee?`,
    answer: `There is a delegation commission fee paid to Stakewithus for staking.`,
  },
  {
    question: `What are the risks?`,
    answer: `Staking risks do apply including slashing involved for downtime and double signing.`,
  },
];
